import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { apiService } from "../../services/apiService";

export const fetchInvestorInvestment = createAsyncThunk(
  "investment/fetchInvestorInvestment",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/investors", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const investorInvestmentSlice = createSlice({
  name: "investorInvestment",
  initialState: {
    investorInvestments: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvestorInvestment.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchInvestorInvestment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.investorInvestments = action.payload.data;
      })
      .addCase(fetchInvestorInvestment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch investor investment";
      });
  },
});

export default investorInvestmentSlice.reducer;
